module.exports = __webpack_public_path__ + "static/media/logo_final.c5fd6ffb.png";